// src/components/ProductCard/ProductMeasurements.jsx

'use client'


import {usePreferences} from '@/contexts/ShopPreferences.context';
import { createFormatters } from '@/lib/formatters.utils';


const pattern = /(?:(\d+)')?(?:(\d+)")?/;  // feet and/or inches


export default function ProductMeasurements({ measurements, lang, side }){

  const { unitSystem } = usePreferences();
  const { formatUnit } = createFormatters(lang, 'short');
  const valueinCM = formatUnit(measurements?.dimensions['SI'][side], measurements?.dimensions['SI'].unit);

  if (unitSystem === 'USC') {
    const match = pattern.exec(measurements?.dimensions[unitSystem][side]);
    const formattedValues = [
      match?.[1] && formatUnit(match[1], 'foot'),
      match?.[2] && formatUnit(match[2], 'inch'),
      `(${valueinCM})`
    ].filter(Boolean);
    return <>{formattedValues.join(' ')}</>;
  } else {
    const uscValue = measurements?.dimensions['USC']?.[side];
    const match = uscValue ? pattern.exec(uscValue) : null;
    const footInchValues = [
      match?.[1] && formatUnit(match[1], 'foot'),
      match?.[2] && formatUnit(match[2], 'inch')
    ].filter(Boolean).join(' ');

    return <>{valueinCM} {footInchValues ? `(${footInchValues})` : ''}</>;
  }
}
